import React from "react";

function formatCost(usd) {
  if (!usd && usd !== 0) return "$0.0000";
  return `$${usd.toFixed(4)}`;
}

function CostUsageTab({ metrics }) {
  if (!metrics) {
    return <div className="mm-empty">No metrics available for this message.</div>;
  }

  const cost = metrics.cost || {};
  const classify = metrics.classify || {};
  const extract = metrics.extract || {};

  const totalDiPages = cost.di_pages_total || 0;
  const totalPrompt = cost.llm_prompt_tokens_total || 0;
  const totalCompletion = cost.llm_completion_tokens_total || 0;
  const totalTokens = totalPrompt + totalCompletion;
  const totalCost = cost.total_cost_usd || 0;
  const diCost = cost.di_cost_usd || 0;
  const llmCost = cost.llm_cost_usd || 0;

  // Proportion for visual bar
  const diPct = totalCost > 0 ? (diCost / totalCost) * 100 : 50;
  const llmPct = totalCost > 0 ? (llmCost / totalCost) * 100 : 50;

  return (
    <div className="cost-container">
      {/* Total cost hero */}
      <div className="cost-hero">
        <div className="cost-hero-amount">{formatCost(totalCost)}</div>
        <div className="cost-hero-label">Total Cost</div>
      </div>

      {/* Cost split bar */}
      <div className="cost-split-bar">
        <div className="cost-split-di" style={{ width: `${diPct}%` }} title={`DI: ${formatCost(diCost)}`} />
        <div className="cost-split-llm" style={{ width: `${llmPct}%` }} title={`LLM: ${formatCost(llmCost)}`} />
      </div>
      <div className="cost-split-legend">
        <span><span className="cost-dot cost-dot-di" /> Document Intelligence {formatCost(diCost)}</span>
        <span><span className="cost-dot cost-dot-llm" /> LLM {formatCost(llmCost)}</span>
      </div>

      {/* Usage cards */}
      <div className="cost-cards">
        <div className="cost-card">
          <div className="cost-card-icon">📄</div>
          <div className="cost-card-body">
            <div className="cost-card-value">{totalDiPages}</div>
            <div className="cost-card-label">DI Pages Processed</div>
            <div className="cost-card-sub">@ $0.01/page</div>
          </div>
        </div>
        <div className="cost-card">
          <div className="cost-card-icon">🤖</div>
          <div className="cost-card-body">
            <div className="cost-card-value">{totalTokens.toLocaleString()}</div>
            <div className="cost-card-label">LLM Tokens</div>
            <div className="cost-card-sub">{totalPrompt.toLocaleString()} in / {totalCompletion.toLocaleString()} out</div>
          </div>
        </div>
      </div>

      {/* Detailed call breakdown */}
      <div className="cost-detail-section">
        <div className="cost-detail-title">DI Call Details</div>
        <div className="cost-detail-table">
          {[...(classify.di_calls || []), ...(extract.di_calls || [])].map((c, i) => (
            <div key={i} className="cost-detail-row">
              <span className="cost-detail-purpose">{c.purpose || c.model || "—"}</span>
              <span className="cost-detail-pages">{c.pages_processed} pg</span>
              <span className="cost-detail-cost">{formatCost((c.pages_processed || 0) * 0.01)}</span>
            </div>
          ))}
          {[...(classify.di_calls || []), ...(extract.di_calls || [])].length === 0 && (
            <div className="cost-detail-empty">No DI calls recorded</div>
          )}
        </div>
      </div>

      <div className="cost-detail-section">
        <div className="cost-detail-title">LLM Call Details</div>
        <div className="cost-detail-table">
          {[...(classify.llm_calls || []), ...(extract.llm_calls || [])].map((c, i) => (
            <div key={i} className="cost-detail-row">
              <span className="cost-detail-purpose">{c.purpose || c.model || "—"}</span>
              <span className="cost-detail-pages">{(c.prompt_tokens + c.completion_tokens).toLocaleString()} tok</span>
              <span className="cost-detail-cost">{formatCost(
                (c.prompt_tokens * 0.15 / 1_000_000) + (c.completion_tokens * 0.60 / 1_000_000)
              )}</span>
            </div>
          ))}
          {[...(classify.llm_calls || []), ...(extract.llm_calls || [])].length === 0 && (
            <div className="cost-detail-empty">No LLM calls recorded</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CostUsageTab;
